import { REHYDRATE, PersistorAction } from 'redux-persist';
import {
  SET_PAGINATION_PAGE,
  RESET_PAGINATION,
  Pagination,
  PaginationActionTypes,
  SET_PAGINATION_TOTAL_PAGES,
} from 'src/ducks/factories/pagination/types';

import { Anything } from '../../../utils/globalTypes';

const initialState: Pagination = {
  totalPages: null,
  page: 1,
};

const pagination = <T>({ prefix, baseReducerState }: { prefix: string; baseReducerState: T }) => {
  return (baseReducer: Anything) =>
    (state = initialState, action: PaginationActionTypes & PersistorAction): Anything => {
      // we are creating a new state based on the state passed our initial state and the reducer state
      // this is because at first the state is empty and if we combine multiple reducers the state must combined
      // from all the states passed
      const newState = { ...initialState, ...baseReducerState, ...state };

      switch (action.type) {
        case SET_PAGINATION_PAGE(prefix): {
          return {
            ...newState,
            page: action.payload,
          };
        }
        case SET_PAGINATION_TOTAL_PAGES(prefix): {
          return {
            ...newState,
            totalPages: action.payload === 0 ? state.totalPages : action.payload,
          };
        }
        case RESET_PAGINATION(prefix): {
          const newStateWithInitialStateAtTop = { ...baseReducerState, ...state, ...initialState };
          return baseReducer(newStateWithInitialStateAtTop, action);
        }
        case REHYDRATE: {
          // we use this case of rehydration for persistance because the new state that we are building will not hold the data
          // that redux-persist pass on action.payload. That's why on this type we check if there is a payload and if there is then we pass
          // to the state the piece of the state from the rehydrated. This will only be needed for factories
          return Object.assign({}, newState, action.payload ? action.payload[prefix] : {});
        }
        default:
          return baseReducer(state, action);
      }
    };
};

export default pagination;
